import React from 'react';
import clsx from 'clsx';
import {i18n} from '@netx/core/i18n';
import {TextField} from '@netx/core-components/TextField';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {CommonRuleEditorProps} from '../../../types';
import {
	customRuleEditorClasses,
	getCustomRuleEditorUtilityClass,
	CustomRuleEditorClasses,
	CUSTOM_RULE_EDITOR_CLASS_NAME,
} from './customRuleEditorClasses';

export type CustomRuleEditorOwnerState = WithClasses<
	CustomRuleEditorClasses,
	{}
>;

const useUtilityClasses = (ownerState: CustomRuleEditorOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getCustomRuleEditorUtilityClass, classes);
};

const CustomRuleEditorRoot = styled('div', {
	name: CUSTOM_RULE_EDITOR_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	flex: '1 1 auto',
	'& > * + *': {
		marginLeft: `${theme.spacing(1)} !important`,
	},
}));

export type CustomRuleEditorProps = WithClasses<
	CustomRuleEditorClasses,
	Pick<CommonRuleEditorProps, 'validationErrors'> & {
		elementValue1: string;
		onValue1Change: (value: string) => void;
	}
>;

const CustomRuleEditorInner = ({
	classes: _classes,
	className,
	elementValue1,
	validationErrors,
	onValue1Change,
}: CustomRuleEditorProps) => {
	const ownerState: CustomRuleEditorOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<CustomRuleEditorRoot className={clsx(classes.root, className)}>
			<TextField
				data-testid="custom-rule-value-1"
				error={validationErrors?.elementValue1?.message}
				fullWidth
				label={i18n.t('i18n.custom')}
				name="rule-value-1"
				value={elementValue1}
				onChange={(event, value) => onValue1Change(value)}
			/>
		</CustomRuleEditorRoot>
	);
};

export const CustomRuleEditorPrimitive = CustomRuleEditorInner;

export const CustomRuleEditor = CustomRuleEditorPrimitive;

export default CustomRuleEditor;

export type CustomRuleEditorGenericProps = WithClasses<
	CustomRuleEditorClasses,
	CommonRuleEditorProps & {}
>;

export const CustomRuleEditorGenericPrimitive = ({
	elementValue1,
	...props
}: CustomRuleEditorGenericProps) => {
	return (
		<CustomRuleEditor {...props} elementValue1={elementValue1.toString()} />
	);
};

export const CustomRuleEditorGeneric = CustomRuleEditorGenericPrimitive;
